<template>
  <section class="list-schedules">
    <div class="list-schedules-itens">
      <Breadcrumb :links="links" />
      <div class="list-schedules-btns">
        <button
          v-for="btn in btnsStatusSchedule"
          :key="btn.id"
          class="list-schedules-btns__element"
          :class="{
            'list-schedules-btns__element--active':
              statusScheduleSelected === btn.id,
          }"
          @click="statusScheduleSelected = btn.id"
        >
          {{ btn.name }}
          <span>({{ countScheduleByIdStatus(btn.id) }})</span>
        </button>
      </div>
      <div class="list-schedules-itens-body">
        <div v-if="hasDataInFiltered" class="row list-schedules__row">
          <div
            class="col-12 col-lg-6 col-xl-4"
            v-for="schedule in filteredAllSchedulesByStatus"
            :key="schedule.id"
          >
            <CardListSchedule :schedule="schedule" />
          </div>
        </div>
        <NotData
          v-else
          :text="'Nenhum agendamento para o status selecionado.'"
        />
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import NotData from "@/components/notData/Index";
import CardListSchedule from "@/views/Professional/components/CardListSchedule";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Profissional",
          routerName: "Professional",
        },
        {
          name: "Listar todos os agendamentos",
          routerName: "ListSchedules",
        },
      ],
      statusScheduleSelected: 1,
      btnsStatusSchedule: [
        {
          id: 1,
          name: "Pendente",
        },
        {
          id: 2,
          name: "Cancelado",
        },
        {
          id: 3,
          name: "Confirmado",
        },
        {
          id: 4,
          name: "Concluído",
        },
      ],
    };
  },
  components: {
    Breadcrumb,
    CardListSchedule,
    NotData,
  },
  computed: {
    ...mapGetters("Professional", ["allSchedules"]),
    filteredAllSchedulesByStatus() {
      return this.allSchedules.filter(
        (item) => item.id_status_schedule === this.statusScheduleSelected
      );
    },
    hasDataInFiltered() {
      return (
        Array.isArray(this.filteredAllSchedulesByStatus) &&
        this.filteredAllSchedulesByStatus.length > 0
      );
    },
  },
  async mounted() {
    await this.consultProfessionalSchedules();
  },
  methods: {
    ...mapActions("Professional", ["consultProfessionalSchedules"]),
    countScheduleByIdStatus(idStatus) {
      const countScheduleStatus = this.allSchedules.filter(
        (item) => item.id_status_schedule === idStatus
      );
      return countScheduleStatus.length;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-schedules {
  padding-bottom: 50px;
  &__row {
    row-gap: 30px;
  }
  &-btns {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 30px;
    margin-bottom: 50px;
    @media (max-width: 991px) {
      gap: 10px;
      margin-bottom: 30px;
    }
    &__element {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 10px;
      background: 0;
      border: 0;
      border-bottom: 2px solid transparent;
      font-size: 20px;
      font-family: "Font Light";
      color: var(--black);
      @media (max-width: 991px) {
        font-size: 12px;
        padding: 0 5px;
      }
      &--active {
        font-family: "Font Semibold";
        font-size: 24px;
        border-color: var(--green);
        @media (max-width: 991px) {
          font-size: 14px;
        }
      }
      span {
        margin-left: 5px;
      }
    }
  }
}
</style>
